import { OptionType } from '@repo/toolkit/types'
import SelectInput, { SelectInputProps } from '@repo/ui/select-input'

import { useFormField } from '../forms/form'

const ControlledSelectInput = <T extends OptionType>(props: SelectInputProps<T>) => {
  const { error } = useFormField()
  return <SelectInput {...props} errorMessage={error ? String(error?.message) : undefined} />
}

export default ControlledSelectInput
